// src/bobs/components/details/workspaceBackground.tsx
import React from "react";
import { Box } from "@mantine/core";
import { Global } from "@emotion/react";

const BG_URL =
  "https://daxwktpz4hkwd.cloudfront.net/vault_images/blue-haze-background.jpg";

const DEFAULTS = {
  hue: "0deg",
  brightness: "0.20",
  tint: "rgba(156,89,86,0.60)",
  offsetY: "2%", // 👈 tweak this in DevTools  (--bg-offset-y)
};

type Props = React.PropsWithChildren<{ wantsGlow: boolean }>;

const WorkspaceBackground: React.FC<Props> = ({ wantsGlow, children }) => (
  <>
    {/* define the offset var globally so you can override per-page */}
    <Global styles={`:root{ --bg-offset-y:${DEFAULTS.offsetY}; }`} />

    <Box
      style={
        {
          position: "relative",
          minHeight: "100vh",
          width: "100%",
          backgroundImage: wantsGlow
            ? `radial-gradient(circle at 50% 30%, rgba(0,180,255,0.35) 0%, transparent 60%), url(${BG_URL})`
            : undefined,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          /* Y-pos driven by CSS var so you can live-tweak */
          backgroundPosition: `center calc(var(--bg-offset-y) + 0)`,
          backgroundAttachment: "fixed",
          "--bg-hue": DEFAULTS.hue,
          "--bg-bright": DEFAULTS.brightness,
          "--bg-tint": DEFAULTS.tint,
        } as React.CSSProperties
      }
    >
      {wantsGlow && (
        <Box
          data-bg-overlay
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "var(--bg-tint)",
            mixBlendMode: "overlay",
            filter:
              "hue-rotate(var(--bg-hue)) brightness(var(--bg-bright)) saturate(1.3)",
            animation: "drift 18s ease-in-out infinite",
            pointerEvents: "none",
            zIndex: 0,
          }}
        />
      )}

      <Box style={{ position: "relative", zIndex: 1 }}>{children}</Box>
    </Box>
  </>
);

export default WorkspaceBackground;
